import { useState, useCallback } from 'react';
import useAxios from './useAxios';
import Constants from '../Constants';
import { toaster } from '../utils/toast';

export const useCaseSettlement = (caseId, _, caseData, onCaseUpdate) => {
    const [isSettlementDialogOpen, setSettlementDialogOpen] = useState(false);
    const { putData, isLoading  } = useAxios();

    const submitCaseSettlement = useCallback(async (values) => {
        const payload = {
            caseId,
            settlements: values
        };

        try {
            const response = await putData(Constants.ApiUrl.case.updateCaseSettledDetails, payload);

            if (response.success) {
                onCaseUpdate(response.data);
                toaster({ message: response.message, success: true });
            } else {
                toaster({ message: response.message || 'Failed to update', success: false });
            }
            setSettlementDialogOpen(false);
        } catch (error) {
            console.error('Error updating settlement:', error);
        }
    }, [caseId, putData]);

    return {
        isSettlementDialogOpen,
        setSettlementDialogOpen,
        submitCaseSettlement,
        isLoading
    };
};

